import { Component, ViewChild } from '@angular/core';
import { KeyboardActivityBaseComponent } from '../keyboard-activity-base.component';
import { FormsModule } from '@angular/forms';
import { Key } from '../../keyboard.types';

@Component({
  selector: 'lib-keyboard-unrestricted-activity',
  imports: [KeyboardActivityBaseComponent, FormsModule],
  templateUrl: './keyboard-unrestricted.component.html',
})
export class KeyboardUnrestrictedComponent {
  @ViewChild('keyboard') protected keyboard!: KeyboardActivityBaseComponent;

  protected addSpace() {
    return this.keyboard.addKey(new Key('&nbsp;', ' '));
  }
}
